import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Home, Search, Phone, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-2xl mx-auto text-center">
        <div className="mb-8">
          <h1 className="text-8xl font-bold text-gray-300 mb-4">404</h1>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Page Not Found
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            The page you're looking for doesn't exist or may have been moved.
          </p>
        </div>

        <Card className="mb-8">
          <CardContent className="p-8">
            <h3 className="text-xl font-semibold mb-4">
              Looking for addiction treatment help?
            </h3>
            <p className="text-gray-600 mb-6">
              Don't let a broken link stop you from getting the help you need. 
              Here are some quick ways to find treatment resources:
            </p>
            
            <div className="grid md:grid-cols-3 gap-4">
              <Button asChild className="w-full">
                <Link to="/search">
                  <Search className="h-4 w-4 mr-2" />
                  Search Facilities
                </Link>
              </Button>
              
              <Button asChild variant="outline" className="w-full">
                <Link to="/get-help">
                  <Phone className="h-4 w-4 mr-2" />
                  Get Help Now
                </Link>
              </Button>
              
              <Button asChild variant="outline" className="w-full">
                <Link to="/">
                  <Home className="h-4 w-4 mr-2" />
                  Go Home
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>

        {/* Emergency Help */}
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 mb-8">
          <h3 className="text-lg font-semibold text-red-800 mb-2">
            Need Immediate Help?
          </h3>
          <p className="text-red-700 mb-4">
            If you're in crisis or need immediate support:
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:988"
              className="inline-flex items-center justify-center px-4 py-2 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-colors"
            >
              <Phone className="h-4 w-4 mr-2" />
              Crisis Line: 988
            </a>
            <a 
              href="tel:1-800-662-4357"
              className="inline-flex items-center justify-center px-4 py-2 border border-red-600 text-red-600 rounded-lg font-medium hover:bg-red-600 hover:text-white transition-colors"
            >
              <Phone className="h-4 w-4 mr-2" />
              1-800-662-HELP
            </a>
          </div>
        </div>

        <Button asChild variant="ghost">
          <button onClick={() => window.history.back()}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Go Back
          </button>
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;